import React from "react";
import { useContextUsModal } from "../hooks";

const ContactUsFeatures = ({ children }) => {
   const { open } = useContextUsModal()

   const onContact = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      open?.();
   }

   return <><a href="" onClick={onContact}>Contact us</a> {children}</>;
}

export default [
   {
      id: "individual",
      name: "Individual",
      description:
         "For individuals looking to book flex office space by the hour, day or longer.",
      price: "$0",
      priceText: "Completely free",
      actionName: "Find a space",
      features: [
         "Access to global marketplace",
         "Pay-as-you-go bookings",
         "Flexible cancellation policy",
         "Standardized license agreement",
      ],
   },
   {
      id: "enterprise",
      name: "Enterprise",
      description: "For teams and large organizations.",
      price: "Contact us",
      priceText: "about a custom quote",
      actionName: "Let's talk",
      features: [
         "Access to on-demand and dedicated office spaces",
         "Tools and insights tailored to your business goals",
         <ContactUsFeatures>to learn more about how LiquidSpace can help unlock the full potential of your portfolio</ContactUsFeatures>,
      ],
   },
];
